import { createSlice } from '@reduxjs/toolkit';

import { initialState } from './initialState';
import { addFloor, changeFloor, fetchFloors, removeFloor } from './services';

export const floorsSlice = createSlice({
  name: 'floors',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(fetchFloors.pending, (state, action) => {
      state.error = undefined;
      state.currentRequests.add(action.meta.arg.buildingId);
    });
    builder.addCase(fetchFloors.rejected, (state, action) => {
      state.error = action.payload;
      state.loading = false;
      state.currentRequests.delete(action.meta.arg.buildingId);
    });
    builder.addCase(fetchFloors.fulfilled, (state, action) => {
      state.loading = false;
      state.currentRequests.delete(action.meta.arg.buildingId);

      const floorIds = new Set<number>();

      for (const floor of action.payload) {
        state.floorsById.set(floor.floorId, floor);
        floorIds.add(floor.floorId);
      }

      if (floorIds.size) {
        state.floorsByBuilding.set(action.meta.arg.buildingId, floorIds);
      } else {
        state.floorsByBuilding.delete(action.meta.arg.buildingId);
      }
    });

    builder.addCase(removeFloor.fulfilled, (state, action) => {
      const floor = state.floorsById.get(action.meta.arg);
      if (!floor) return;

      state.floorsById.delete(floor.floorId);
      const nextFloorsByBuilding = state.floorsByBuilding.get(floor.buildingId);
      if (!nextFloorsByBuilding) return;

      nextFloorsByBuilding.delete(floor.floorId);
      if (nextFloorsByBuilding.size) {
        state.floorsByBuilding.set(floor.buildingId, nextFloorsByBuilding);
      } else {
        state.floorsByBuilding.delete(floor.buildingId);
      }
    });

    builder.addCase(addFloor.fulfilled, (state, action) => {
      state.floorsById.set(action.payload.floorId, action.payload);
      const nextFloorsByBuilding =
        state.floorsByBuilding.get(action.payload.buildingId) ??
        new Set<number>();
      nextFloorsByBuilding.add(action.payload.floorId);
      state.floorsByBuilding.set(
        action.payload.buildingId,
        nextFloorsByBuilding,
      );
    });

    builder.addCase(changeFloor.fulfilled, (state, action) => {
      state.floorsById.set(action.payload.floorId, action.payload);
      const nextFloorsByBuilding =
        state.floorsByBuilding.get(action.payload.buildingId) ??
        new Set<number>();
      nextFloorsByBuilding.add(action.payload.floorId);
      state.floorsByBuilding.set(
        action.payload.buildingId,
        nextFloorsByBuilding,
      );
    });
  },
});

export const { actions: floorsActions, reducer: floorsReducer } = floorsSlice;
